module.exports = __webpack_public_path__ + "static/media/MiraDigital_white.762163ea.png";